import React from 'react';
import { useRooftop } from '@store';
import type { Appointments as AppointmentsConfig } from '@hopdrive/sdk-configs';
import DefaultFallback from '@components/Fallbacks/DefaultFallback';
import AppointmentsQuery from '../components/AppointmentsQuery';

const AppointmentsPage: React.FC = () => {
  const rooftop = useRooftop();

  const appointmentsEnabled =
    (rooftop?.effective_config as { appointments?: AppointmentsConfig } | undefined)?.appointments?.enabled === true;

  if (!appointmentsEnabled) {
    return <DefaultFallback fullscreen severity='error' message='RESTRICTED ACCESS' />;
  }

  return <AppointmentsQuery />;
};

export default AppointmentsPage;
